const lmz046 = [
    [
        -86.749599900000007,
        41.800300999999997
    ],
    [
        -86.777227000000011,
        41.784739999999999
    ],
    [
        -86.802427400000013,
        41.771939199999998
    ],
    [
        -86.801925600000018,
        41.771240200000001
    ],
    [
        -86.804028000000017,
        41.771039999999999
    ],
    [
        -86.824485300000021,
        41.7604179
    ],
    [
        -86.837226800000025,
        41.754440299999999
    ],
    [
        -86.860929000000027,
        41.743839000000001
    ],
    [
        -86.875198300000022,
        41.7380104
    ],
    [
        -86.888930000000016,
        41.732638999999999
    ],
    [
        -86.909126200000017,
        41.726936299999998
    ],
    [
        -86.908927900000023,
        41.726638699999995
    ],
    [
        -86.905929500000028,
        41.727439799999992
    ],
    [
        -86.905303900000021,
        41.725341699999994
    ],
    [
        -86.907693900000027,
        41.724298799999993
    ],
    [
        -86.958828100000034,
        41.791968399999995
    ],
    [
        -86.940998800000031,
        41.803876099999997
    ],
    [
        -86.931755700000025,
        41.807082599999994
    ],
    [
        -86.91552310000003,
        41.811663599999996
    ],
    [
        -86.893630300000027,
        41.820439999999998
    ],
    [
        -86.86146410000002,
        41.835051199999995
    ],
    [
        -86.840858300000022,
        41.845667599999999
    ],
    [
        -86.840139900000025,
        41.846188900000001
    ],
    [
        -86.816533600000028,
        41.858178800000005
    ],
    [
        -86.806355700000026,
        41.863909100000008
    ],
    [
        -86.749599900000007,
        41.800300999999997
    ]
];

export default lmz046;
